"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _immutable = _interopRequireDefault(require("immutable"));

var _styledComponents = require("styled-components");

var _colors = require("HubStyleTokens/colors");

var _theme = require("HubStyleTokens/theme");

var _marketingDotComNav = require("marketing-dot-com-nav");

var _layout = require("../../constants/layout");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  #hsg-nav-2016,\n  #hsg-nav-global {\n    > div > nav,\n    > nav {\n      background-color: ", ";\n      border-bottom: 1px solid ", ";\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  .hsg-page-width-normal,\n  .hs-page-width-normal {\n    max-width: ", "px !important;\n    padding: 0 !important;\n\n    @media (min-width: 768px) {\n      padding: 0 ", "px !important;\n    }\n  }\n\n  .hsg-nav__group-item.hsg-nav__group-item--cta {\n    @media (min-width: 768px) {\n      padding-right: 0;\n    }\n  }\n\n  .hsg-nav__group-item.hsg-nav__group-item--search {\n    display: none;\n  }\n\n  .hsg-nav__group-item > #hsg-nav__logo > #hsg-nav__logo-mobile {\n    display: none;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var GlobalHeaderStyle = (0, _styledComponents.createGlobalStyle)(_templateObject(), _layout.MAIN_SECTION_MAX_WIDTH, _layout.MAIN_SECTION_PADDING_X);
var MarketplaceNavStyle = (0, _styledComponents.createGlobalStyle)(_templateObject2(), _colors.OLAF, _theme.TEMPLATE_SECTION_DIVIDER_BORDER_COLOR);

var MarketingNavHeader = function MarketingNavHeader(_ref) {
  var contentBlob = _ref.contentBlob,
      lang = _ref.lang,
      variation = _ref.variation;
  var HeaderComponent = (0, _react.useMemo)(function () {
    if (lang === 'ja') {
      return _marketingDotComNav.Header.jp;
    }

    return _marketingDotComNav.Header[lang] || _marketingDotComNav.Header.en;
  }, [lang]);
  var defaultContentBlob = HeaderComponent.contentBlob;
  var computedContentBlob = (0, _react.useMemo)(function () {
    if (!(contentBlob && defaultContentBlob)) {
      return contentBlob;
    }

    return _immutable.default.fromJS(defaultContentBlob).mergeDeep(contentBlob).toJS();
  }, [contentBlob, defaultContentBlob]);
  return _react.default.createElement(_react.Fragment, null, _react.default.createElement(GlobalHeaderStyle, null), variation === 'marketplace' && _react.default.createElement(MarketplaceNavStyle, null), _react.default.createElement(HeaderComponent, {
    contentBlob: computedContentBlob,
    isLoggedIn: false,
    variation: variation
  }));
};

MarketingNavHeader.propTypes = {
  contentBlob: _propTypes.default.object,
  lang: _propTypes.default.string,
  variation: _propTypes.default.oneOf(['default', 'marketplace'])
};
MarketingNavHeader.defaultProps = {
  lang: 'en',
  variation: 'marketplace'
};
var _default = MarketingNavHeader;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/components/nav/MarketingNavHeader.js
// module id = 1177
// module chunks = 212